<p-dialog header="Session Expiry Warning" [resizable]="false" [(visible)]="showWarningSignal" [modal]="true" [closable]="false" [draggable]="false" [dismissableMask]="false"
    styleClass="inactivity-timer">
    <p> Your session is about to expire. Would you like to extend your session? </p>
    <div class="text-center">
        <h5>{{ formattedTimeSignal() }}</h5>
    </div>
    <div>
        <!-- DO NOT remove this. Needed so the two buttons shown don't auto focuss -->
        <p-button label="HideFocus" styleClass="hidden" severity="secondary"> </p-button>
    </div>
    <div class="w-full flex justify-center mt-6 gap-4">
        <p-button label="Extend" [disabled]="extendSessionButtonDisabled()" (click)="onExtendSessionButtonClick()"> </p-button>
        <p-button label="Logout" (click)="onLogoutButtonClick()" severity="secondary"> </p-button>
    </div>
</p-dialog>